import React from "react";
import { Linking, View, Text } from "react-native";

import IntegrationsHelper, { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import AccountsList from "./AccountsList";
import Disconnect from "./Disconnect";
import Reconnect from "./Reconnect";
import SnoozeIntegrationDialog from "../../common/SnoozeIntegrationDialog";
import appPages from "../../../../../appPages";
import HealthEmptyWebScreen from "./HealthEmptyWebScreen";
import { isWeb } from '../../../../../helpers/utils';

export default class HealthSyncPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    //const account = this.controller.state.impersonate || this.controller.state.currentUser;
    const account =
      this.controller.apiService.deviceInfo.name ||
      this.controller.state.currentUser;

    const params = this.getArgs() || {};

    // Send email if users presses Health from Desktop
    if (isWeb && !params.isActive) this.sendEmail();

    this.state = {
      reconnect: params.reconnect,
      title: params.title,
      accounts: this.controller.getDevices("apple_health"),
      isActive: params.isActive,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  goBack = () => {
    this.controller.goBack();
  };

  configureAccount = () => {
    Linking.openURL("App-Prefs:root=HealthKit");
  };

  updateAttributeSettings = (account, attribute, value) => {
    attribute.isSelected = value;
    saveIntegrations({
      id: account.id,
      streamId: attribute.id,
      streamEnabled: value,
    });
  };

  saveIntegrations = (data, redirect = false) => {
    IntegrationsHelper.saveIntegrationSource(this.controller, data, () => {
      if (redirect) {
        this.controller.getItems(appPages.integrationsV2);
      }
    });
  };

  // ------------------------------------- SNOOZE -------------------------------------
  onCancel = (selectedAccount) => {
    const { accounts } = this.state;

    accounts.forEach((acc) => {
      if (acc.id == selectedAccount.id) acc.isEnabled = true;
    });

    this.setState((state) => ({ ...state, accounts, snoozeAccount: null }));
  };

  toggleAccountStatus = (account, isEnabled) => {
    if (!isEnabled) {
      this.setState((state) => ({ ...state, snoozeAccount: account }));
      return;
    }

    this.setState((state) => ({
      ...state,
      snoozeAccount: null,
      selectedDisconnectAcc: null,
    }));

    const data = {
      [INTEGRATION_KEYS.health]: isEnabled,
      account: account.email,
      id: account.id,
      isEnabled: isEnabled,
    };

    this.saveIntegrations(data);
  };

  showDisconnectPage = (acc) => {
    this.setState((state) => ({ ...state, selectedDisconnectAcc: acc }));
  };

  disconnectAccount = () => {
    const { selectedDisconnectAcc } = this.state;
    this.saveIntegrations(
      {
        [INTEGRATION_KEYS.health]: false,
        disconnect: true,
        id: selectedDisconnectAcc.id,
      },
      true,
    );
  };

  sendEmail = () => {
    console.log("Email Instructions");

    this.controller.cardAction(
      {
        action: "email_instructions",
        type: "health",
      },
      () => {},
      () => {},
    );
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      accounts,
      selectedDisconnectAcc,
      snoozeAccount,
      reconnect,
      title,
      isActive,
    } = this.state;

    const showEmptyScreen = !isActive && isWeb;

    return (
      <>
        <SnoozeIntegrationDialog
          controller={this.controller}
          account={snoozeAccount}
          integrationName={INTEGRATION_KEYS.health}
          saveIntegrations={this.saveIntegrations}
          onCancel={this.onCancel}
        />
        {selectedDisconnectAcc ? (
          <Disconnect
            goBack={() => this.showDisconnectPage(null)}
            configureAccount={this.configureAccount}
            disconnectAccount={this.disconnectAccount}
            turnOff={() =>
              this.toggleAccountStatus(selectedDisconnectAcc, false)
            }
          />
        ) : reconnect ? (
          <Reconnect
            account={title || snoozeAccount?.name}
            goBack={this.goBack}
            saveIntegrations={this.saveIntegrations}
          />
        ) : showEmptyScreen ? (
          <HealthEmptyWebScreen
            sendEmail={this.sendEmail}
            goBack={this.goBack}
          />
        ) : (
          <AccountsList
            controller={this.controller}
            accounts={accounts}
            goBack={this.goBack}
            disconnectAccount={this.showDisconnectPage}
            toggleAccountStatus={this.toggleAccountStatus}
            editAccount={this.showDisconnectPage}
          />
        )}
      </>
    );
  }
}
